export const networkMapper = (network: string) => {
  switch (network) {
    case "USDT.TRC20":
      return "TRX";
    case "USDT.BEP20":
      return "BNB";
  }
};
